import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const saveToHistorySchema = z.object({
  branchId: z.string(),
});

export const saveToHistory = mutator({
  schema: saveToHistorySchema,
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { branch } }) => {
    if (!branch.headCommitId)
      throw userFacingError("Branch has no head commit");

    const [headCommit] = await tx.run(
      zql.workflowCommits.where("id", branch.headCommitId)
    );
    if (!headCommit) throw userFacingError("Commit not found");
    if (headCommit.message != null) throw userFacingError("Already saved");
  },
});
